/**
 * @generated SignedSource<<889c39d2661380832e52c65219a4ef6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleSectionHeaderStatusDot_routineOccasion$data = {
  readonly status: RoutineOccasionStatus;
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentType": "TeamScheduleSectionHeaderStatusDot_routineOccasion";
};
export type TeamScheduleSectionHeaderStatusDot_routineOccasion$key = {
  readonly " $data"?: TeamScheduleSectionHeaderStatusDot_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderStatusDot_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleSectionHeaderStatusDot_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "95d5e9a93330747e7bcfc4172d376a0d";

export default node;
